import { Box, BoxProps } from "@chakra-ui/react";
import { FiMonitor } from "react-icons/fi";

export const MonitorIcon = (props: BoxProps) => {
  return <Box as={FiMonitor} height="20px" width="20px" {...props} />;
};
